import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Radio from './src/radio.vue'
import RadioButton from './src/radio-button.vue'
import RadioGroup from './src/radio-group.vue'

export const SgRadio = withInstall(Radio, {
  RadioButton,
  RadioGroup,
})
export default SgRadio
export const SgRadioGroup = withNoopInstall(RadioGroup)
export const SgRadioButton = withNoopInstall(RadioButton)

export * from './src/radio'
export * from './src/radio-group'
export * from './src/radio-button'
export * from './src/constants'
